import { Link } from 'react-router-dom';
import styled from 'styled-components';
import propsToCss from '../utils/propsToCss';
const RouterLink = styled(Link)`
  ${props => propsToCss(props)}
`;
export { RouterLink };